import { Risk, Unit, Value } from "./units";

export type RangeLabel =
  | "elevated"
  | "diabetes"
  | "high"
  | "low"
  | "mild"
  | "moderate"
  | "normal"
  | "optimal"
  | "pre-diabetes"
  | "very high"
  | "very low";

export type RiskRange = {
  from: number;
  to: number;
  risk: Risk;
  label?: RangeLabel;
};

export function findRange(ranges: readonly RiskRange[], value: number) {
  return ranges.find((range) => {
    return value >= range.from && value <= range.to;
  });
}

export class RiskRanges<U extends Unit> {
  unit: U;
  entries: readonly RiskRange[];

  constructor(unit: U, ranges: RiskRange[]) {
    this.unit = unit;
    this.entries = ranges;
  }

  findRange = (value: Value<U>) => {
    return findRange(this.entries, value[this.unit]);
  };

  findRisk = (value: Value<U>) => {
    return this.findRange(value)?.risk ?? Risk.Unknown;
  };
}
